import { Chip, Tooltip, Box, Typography } from "@mui/material";
import {
  CheckCircle,
  Warning,
  Error as ErrorIcon,
} from "@mui/icons-material";

const getQualityInfo = (score) => {
  if (score >= 80) return { color: "success", icon: <CheckCircle sx={{ fontSize: 14 }} />, label: "Good" };
  if (score >= 50) return { color: "warning", icon: <Warning sx={{ fontSize: 14 }} />, label: "Review" };
  return { color: "error", icon: <ErrorIcon sx={{ fontSize: 14 }} />, label: "Attention" };
};

export default function QualityIndicator({ score, issues = [], size = "small" }) {
  if (score === undefined || score === null) return null;

  const info = getQualityInfo(score);

  const tooltipContent = (
    <Box sx={{ p: 0.5 }}>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
        Quality: {score}/100
      </Typography>
      {issues.length > 0 && (
        <Box component="ul" sx={{ m: 0, pl: 2, fontSize: "0.75rem" }}>
          {issues.slice(0, 5).map((issue, i) => (
            <li key={i}>{issue}</li>
          ))}
        </Box>
      )}
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="top">
      <Chip
        icon={info.icon}
        label={score}
        color={info.color}
        size={size}
        variant="outlined"
        sx={{
          height: size === "small" ? 22 : 28,
          fontSize: size === "small" ? "0.7rem" : "0.8rem",
          "& .MuiChip-icon": { ml: 0.5 },
        }}
      />
    </Tooltip>
  );
}

export function QualityBadge({ qualityReport }) {
  if (!qualityReport) return null;

  const { average_score, needs_attention, score_distribution } = qualityReport;
  const info = getQualityInfo(average_score || 0);

  return (
    <Tooltip
      title={
        <Box sx={{ p: 0.5 }}>
          <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
            Quality Report
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
            Excellent: {score_distribution?.excellent || 0} | Good: {score_distribution?.good || 0} |
            Review: {score_distribution?.needs_review || 0} | Poor: {score_distribution?.poor || 0}
          </Typography>
          {needs_attention > 0 && (
            <Typography variant="body2" color="warning.main" sx={{ fontSize: "0.75rem", mt: 0.5 }}>
              {needs_attention} question{needs_attention > 1 ? 's' : ''} need attention
            </Typography>
          )}
        </Box>
      }
      arrow
    >
      <Chip
        icon={info.icon}
        label={`Quality: ${Math.round(average_score || 0)}/100`}
        color={info.color}
        size="small"
        sx={{ fontWeight: 600 }}
      />
    </Tooltip>
  );
}
